export const SPARE_KEY_STATUS = [
  { label: 'Need to Ask Customer', value: 25 },
  { label: 'None', value: 5 },
  { label: 'Customer to Provide', value: 6 },
  { label: 'Available', value: 7 },
  { label: 'Sold/Delivered & Provided to Customer', value: 24 }
];
